import { EKanbanCardProperty, IGetState, TBoardId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import {
    boardSetDefaultCardPreviewHiddenProperties
} from '../../../../../../../../../rest/effects/board/boardSetDefaultCardPreviewHiddenProperties';
import {
    getBoardDefaultCardPreviewHiddenProperties
} from '../../../../../../../../../store/model/board/selectors/getBoardDefaultCardPreviewHiddenProperties';
import { getPreviewKey } from '../helpers/getPreviewKey';
import { EAsidePanelProperty } from '../../../../../../asidePanel/components/AsidePanel/types';
import {
    boardUserMetaSetCardPreviewHiddenProperties
} from '../../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewHiddenProperties';
import { getToggledProperties } from '../../../../../../preview/Preview/hocs/PreviewHOC/selectors/getToggledProperties';
import {
    SegmentCardEvent, SegmentCardOptions, SegmentCardOptionStatusValue,
    SegmentCardPreviewSettingsSourceValue
} from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { segmentTrackAction } from '../../../../../../../../../middlewares/segment';

export const onPreviewToggle = (
    boardId: TBoardId,
    cardProperty: EKanbanCardProperty | EAsidePanelProperty,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const key = getPreviewKey(cardProperty);
        const properties = getBoardDefaultCardPreviewHiddenProperties(getState(), boardId);
        const newProperties = getToggledProperties(properties, key);
        let isOn = false;
        if (newProperties.length > properties.length) {
            isOn = true;
        }
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_PREVIEW_SETTING_SELECTED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardPreviewSettingsSourceValue.BOARD_SETTINGS
        }, [
            {
                name: SegmentCardOptions.TYPE,
                value: key.toLowerCase().replace('_', ''),
            },
            {
                name: SegmentCardOptions.STATUS,
                value: isOn ? SegmentCardOptionStatusValue.ON : SegmentCardOptionStatusValue.OFF,
            }
        ]));
        dispatch(boardSetDefaultCardPreviewHiddenProperties(boardId, newProperties));
        dispatch(boardUserMetaSetCardPreviewHiddenProperties(boardId, newProperties));
    };
    return action;
};
